import React from 'react';
import classnames from 'classnames';

import {
  Countries,
  filterStateByCountry,
  type IStateObject,
  type StateCode } from
'~/services/actions/state-actions';

import OCButton from '../../../../button';

import styles from './styles/mobile-dropdown.module.css';

interface IProps {
  selectedState: StateCode;
  setSelectedState: (state: StateCode) => void;
  supportedStates: IStateObject[];
}

const MobileStateDropdown = ({
  selectedState,
  setSelectedState,
  supportedStates
}: IProps) => {
  return (
    <div className={styles.wrapper} data-testid="mobile-states">
			<div className={styles.stateButtons}>
				{[Countries.US, Countries.CANADA].map((country) => {
          const countryStates = supportedStates.filter(({ stateCode }) =>
          filterStateByCountry(stateCode, country)
          );

          if (!countryStates.length) {
            return null;
          }

          return (
            <React.Fragment key={country}>
							<div data-testid="country-title" className={styles.countryName}>
								{country}
							</div>
							<div data-testid="state-grid" className={styles.mobileGrid}>
								{countryStates.map((state) => {
                  return (
                    <OCButton
                      key={state.stateCode}
                      onClick={() => setSelectedState(state.stateCode)}
                      className={classnames(
                        styles.state,
                        selectedState === state.stateCode ?
                        styles.selected :
                        ''
                      )}>

											{state.stateName}
										</OCButton>);

                })}
							</div>
						</React.Fragment>);

        })}
			</div>
		</div>);

};

export default MobileStateDropdown;